import { useMemo, useCallback } from 'react';
import type { Field } from '@formily/core';
import { useField } from '@formily/react';
import { observer } from '@formily/reactive-react';
import Editor from '../../../components/Editor/Editor';
import { buildEditorConfig } from './buildEditorConfig';
import type { IFormEditorProps } from './index';
import useInitEditor from './useInitEditor';

const EditorForRunTime = observer(({}) => {
  const field = useField<Field>();
  const componentProps = (field.componentProps || {}) as IFormEditorProps;

  const editorConfig = useMemo(
    () => buildEditorConfig(componentProps),
    [
      componentProps.height,
      componentProps.placeholder,
      componentProps.menubar,
      componentProps.statusbar,
      componentProps.branding,
      componentProps.toolbarGroups,
    ]
  );

  const handleChange = useCallback(
    (value: string) => {
      field.onInput(value);
    },
    [field.onInput]
  );

  const handleEditorInit = useInitEditor({ componentProps, handleChange });

  if (componentProps.visible === false) return null;

  return (
    <Editor
      value={field.value || ''}
      onChange={handleChange}
      disabled={componentProps.disabled || field.disabled}
      config={editorConfig}
      onEditorInit={handleEditorInit}
    />
  );
});

export default EditorForRunTime;
